// Styles for Footer go here.
import styled from 'styled-components';
import { theme } from '../../../styles';

export const StyledHero = styled.div`
  /* hero */
  .lt-hero {
    padding: 40px 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    height: 590px;

    &.lt-header-overlay {
      margin-top: 123.8px;
    }
    @media ${theme.ltMediaQuery.tablet} {
      &.lt-header-overlay {
        margin-top: 106px;
      }
    }
  }
  @media ${theme.ltMediaQuery.tablet} {
    .lt-hero {
      align-items: center;
      height: 671px;
    }
  }
  .lt-hero::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -2;
    background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 55.04%, rgba(0, 0, 0, 0.62) 100%);
  }
  .lt-hero .hero-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .lt-hero-text {
    position: relative;
    z-index: 1;
  }
  .lt-hero-text h1 {
    color: ${theme.colors.white};
    max-width: 360px;
    margin-bottom: 20px;
  }
  @media ${theme.ltMediaQuery.tablet} {
    .lt-hero-text h1 {
      max-width: 550px;
      margin-bottom: 32px;
    }
  }
  .lt-hero-text .button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 15px 10px 18px;
    background-color: #ff9662;
    border-radius: 20px;
  }
  .lt-hero-text .button img {
    width: auto;
  }
`;
